/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  get(params = {}, cache = false) {
    if (typeof params === 'boolean') {
      return super.get(params);
    }

    if (cache) {
      return super.get(true);
    }

    return this.getFromNetwork(params);
  }

  getFromNetwork(params = {}) {
    return axios.get(this.url, { params });
  }

  bulkDelete(ids) {
    return axios.delete(`${this.url}/bulk_destroy`, { data: { ids } });
  }
}

export default new LabelsAPI();
